<script lang="ts">
    export let onSearch = (searchValue: string) => {};
    export let onClose = () => {};

    let searchValue = "";

    function handleKeydown(event) {
        if (event.keyCode === 13) {
            search();
        }
        if (event.keyCode == 27) {
            close();
        }
    }

    function search() {
        onSearch(searchValue);
    }

    function close() {
        onClose();
    }
</script>

<div id="search" class="px-2">
    <div id="search-icon">
        <div class="icon">
            <i class="fas fa-search" />
        </div>
    </div>
    <div id="search-input">
        <input
            class="input"
            type="text"
            placeholder="Rechercher un produit"
            bind:value={searchValue}
            on:keydown={handleKeydown}
        />
    </div>
    <div id="search-icons">
        <div class="icon-arrow" on:click={search}>
            <span class="icon">
                <i class="fas fa-arrow-right"></i>            
            </span>
        </div>
    </div>
</div>

<style lang="scss">
    @import "../styles/variables.scss";

    // .button {
    //     background-color: $light-sky;
    //     color: white;
    // }

    #search {
        display: flex;
        flex-direction: row;
        justify-content: center;
        height: 55px;
        border-radius: 0.5rem;
        color: #666666;
        border: 1px solid rgba(0,0,0,0.2);
        background-color: #f8f5f4;
        outline: none;
        #search-icon {
            width: 2rem;
            color: #666666;
            text-align: center;
            display: flex;
            .icon {
                display: flex;
                justify-content: center;
                margin: auto;
            }
        }

        #search-input {
            width: 80%;
            display: flex;
            margin: auto;
            input {
                padding: 0;
                padding-left: 1em;
                background-color: transparent;
                color: #666666;
                font-size: 16px;
                font-style: italic;
                border: none;
                box-shadow: none;
            }
            input::placeholder {
                color: #666666;
            }
            @media (max-width: $mobile-breakpoint) {
                width: 95%;
            }
        }

        #search-icons {
            display: flex;
            flex-direction: row;
            gap: 2px;
            // width: 15%;
            // margin: auto;
            align-items: center;

            @media (max-width: $mobile-breakpoint) {
                display: none;
            }
            div {
                width: 50px;
                height: 50px;
                border-radius: 10px;
                display: flex;
                cursor: pointer;
            }

            .icon {
                display: flex;
                justify-content: center;
                margin: auto;
            }

            .icon-arrow {
                background-color: #000;
                color: white;
            }

            .icon-cancel {
                background-color: red;
                color: #000;
            }
        }
    }
</style>
